module.exports = __webpack_public_path__ + "static/img/coupon.c2fd77e6.png";